// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chats-panel__container {
    height: 100%;
    background-color: rgb(102,102,102);
    display: flex;
    flex-direction: column;
}

.chats-panel__chat-list {
    display: flex; 
    flex-direction: column;
}

.chat-panel__operator-status-container select {
    font-size: 1.4rem !important;
    padding: 0rem;
    height: 3rem;
    display: block;
    color: white;
    border: 0;
    border: none;
}

.chat-panel__selected-status-1 {
    background-color: rgb(0, 199, 0);
}

.chat-panel__selected-status-2 {
    background-color: rgb(206, 206, 58);
}

.chat-panel__selected-status-3 {
    background-color: red;
}

.chat-panel__operator-status-online {
    background-color: rgb(0, 199, 0) !important;
}

.chat-panel__operator-status-afk {
    background-color: rgb(206, 206, 58) !important;
}

.chat-panel__operator-status-offline {
    background-color: red !important;
}

.chat-panel__chat-items-container {
    margin-top: auto;
    padding: 0;
    display: flex;
    justify-content: center;
    overflow-y: auto;
    overflow-x: hidden;
}

    .chat-panel__chat-items-container::-webkit-scrollbar-track {
        background-color: #b8b8b8;
    }

    .chat-panel__chat-items-container::-webkit-scrollbar {
        width: 0.7rem;
    }

.chat-panel__chat-items-container::-webkit-scrollbar-thumb {
    background-color: #7a7a7a;
    border: none;
}

.chat-panel__chat-items-container button:first-child {
    margin-top: 1rem;
}

.chats-panel__logout {
    cursor: pointer;
    margin: 1rem auto 0.3rem auto;
    width: 7rem !important;
    height: 7rem !important;
    border-radius: 50%;
}

.chats-panel__logout svg {
    width: 100% !important;
    height: 100% !important;
}

.chat-panel__operator-name {
    font-size: 1.4rem;
    color: rgb(184, 184, 184);
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 0.5rem;
}

.profile-dropdown__item {
    padding: 0.2rem;
    background: none;
    border: none;
    text-align: left;
    font-size: 1rem;
}

    .profile-dropdown__item.first {
        padding: 0.4rem 0.4rem 0.2rem 0.4rem;
    }

    .profile-dropdown__item.last {
        padding: 0.2rem 0.4rem 0.4rem 0.4rem;
    }

    .profile-dropdown__item.mid {
        padding: 0.2rem 0.4rem 0.2rem 0.4rem;
    }

    .profile-dropdown__item:hover {
        transition: 0.3s;
        background: #34495e;
    }

.profile-dropdown {
    position: fixed;
    right: 0.1rem;
    top: 4rem;
}

.profile-dropdown__menu {
    display: flex;
    flex-direction: column;
    border: 1px solid black;
    background: white;
}

.profile-dropdown__link {
    color: black;
}

button.chat-item-active-element {
    background: none;
    border: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/chats-panel/ChatsPanel.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kCAAkC;IAClC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;AAEJ;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;IAEI;QACI,oCAAoC;IACxC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;AAEJ;IACI,eAAe;IACf,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB","sourcesContent":[".chats-panel__container {\r\n    height: 100%;\r\n    background-color: rgb(102,102,102);\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.chats-panel__chat-list {\r\n    display: flex; \r\n    flex-direction: column;\r\n}\r\n\r\n.chat-panel__operator-status-container select {\r\n    font-size: 1.4rem !important;\r\n    padding: 0rem;\r\n    height: 3rem;\r\n    display: block;\r\n    color: white;\r\n    border: 0;\r\n    border: none;\r\n}\r\n\r\n.chat-panel__selected-status-1 {\r\n    background-color: rgb(0, 199, 0);\r\n}\r\n\r\n.chat-panel__selected-status-2 {\r\n    background-color: rgb(206, 206, 58);\r\n}\r\n\r\n.chat-panel__selected-status-3 {\r\n    background-color: red;\r\n}\r\n\r\n.chat-panel__operator-status-online {\r\n    background-color: rgb(0, 199, 0) !important;\r\n}\r\n\r\n.chat-panel__operator-status-afk {\r\n    background-color: rgb(206, 206, 58) !important;\r\n}\r\n\r\n.chat-panel__operator-status-offline {\r\n    background-color: red !important;\r\n}\r\n\r\n.chat-panel__chat-items-container {\r\n    margin-top: auto;\r\n    padding: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n}\r\n\r\n    .chat-panel__chat-items-container::-webkit-scrollbar-track {\r\n        background-color: #b8b8b8;\r\n    }\r\n\r\n    .chat-panel__chat-items-container::-webkit-scrollbar {\r\n        width: 0.7rem;\r\n    }\r\n\r\n.chat-panel__chat-items-container::-webkit-scrollbar-thumb {\r\n    background-color: #7a7a7a;\r\n    border: none;\r\n}\r\n\r\n.chat-panel__chat-items-container button:first-child {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.chats-panel__logout {\r\n    cursor: pointer;\r\n    margin: 1rem auto 0.3rem auto;\r\n    width: 7rem !important;\r\n    height: 7rem !important;\r\n    border-radius: 50%;\r\n}\r\n\r\n.chats-panel__logout svg {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n}\r\n\r\n.chat-panel__operator-name {\r\n    font-size: 1.4rem;\r\n    color: rgb(184, 184, 184);\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    padding: 0 0.5rem;\r\n}\r\n\r\n.profile-dropdown__item {\r\n    padding: 0.2rem;\r\n    background: none;\r\n    border: none;\r\n    text-align: left;\r\n    font-size: 1rem;\r\n}\r\n\r\n    .profile-dropdown__item.first {\r\n        padding: 0.4rem 0.4rem 0.2rem 0.4rem;\r\n    }\r\n\r\n    .profile-dropdown__item.last {\r\n        padding: 0.2rem 0.4rem 0.4rem 0.4rem;\r\n    }\r\n\r\n    .profile-dropdown__item.mid {\r\n        padding: 0.2rem 0.4rem 0.2rem 0.4rem;\r\n    }\r\n\r\n    .profile-dropdown__item:hover {\r\n        transition: 0.3s;\r\n        background: #34495e;\r\n    }\r\n\r\n.profile-dropdown {\r\n    position: fixed;\r\n    right: 0.1rem;\r\n    top: 4rem;\r\n}\r\n\r\n.profile-dropdown__menu {\r\n    display: flex;\r\n    flex-direction: column;\r\n    border: 1px solid black;\r\n    background: white;\r\n}\r\n\r\n.profile-dropdown__link {\r\n    color: black;\r\n}\r\n\r\nbutton.chat-item-active-element {\r\n    background: none;\r\n    border: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
